import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'FormatNumberForKm'
  })
  export class FormatNumberPipe implements PipeTransform {
    transform(value: number | string | null | undefined, decimals: number = 1): string {
      if (value === null || value === undefined || value === '') {
        return '0';
      }
  
      const num = typeof value === 'string' ? parseFloat(value) : value;
      
      if (isNaN(num)) {
        return '0';
      }
  
      const rounded = Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
      
      const parts = rounded.toString().split('.');
      
      if (parts.length === 1) {
        return parts[0];
      }
      
      const decimalPart = parts[1].replace(/0+$/, '');
      
      return decimalPart.length > 0 
        ? `${parts[0]}.${decimalPart}`
        : parts[0];
    }
  }
  
  